import { useState } from "react";
import { Spinner } from "react-bootstrap";
import { useTenantAuth } from "../../../../context/TeanantAuthProvider";
import ChangePasswordModal from "../../../common/ChangePasswordModal";
import CustomInput from "../../../common/CustomInput";
import { Formik, Form } from "formik";
import { useChangePassword } from "../../../../hooks/tenant/useChangePassword";

const SettingsForm = () => {
  const { currentUser, loading: authLoading } = useTenantAuth();
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [passwordSuccess, setPasswordSuccess] = useState(false);

  const {
    changePassword,
    loading: passwordLoading,
    error: passwordError,
    setError,
  } = useChangePassword();

  const handleOpenPasswordModal = () => {
    setPasswordSuccess(false);
    setShowPasswordModal(true);
    setError("");
  };

  const handleClosePasswordModal = () => {
    setShowPasswordModal(false);
    setPasswordSuccess(false);
    setError("");
  };

  const handleChangePassword = async (values) => {
    const success = await changePassword({
      currentPassword: values.currentPassword,
      newPassword: values.newPassword,
    });

    if (success) {
      setPasswordSuccess(true);
      // Close modal after 2 seconds on success
      setTimeout(() => {
        handleClosePasswordModal();
      }, 2000);
    }

    return success;
  };

  // Show loading state while fetching user data
  if (authLoading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" role="status" variant="primary">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
        <p className="mt-2 text-muted">Loading settings...</p>
      </div>
    );
  }

  // Get user details from context
  const userName = currentUser?.name
    ? currentUser.name
    : currentUser?.firstName
      ? `${currentUser.firstName} ${currentUser.lastName || ""}`.trim()
      : "User";
  const userEmail = currentUser?.email || "";

  return (
    <>
      <div className="p-4 shadow-sm rounded bg-white">
        <Formik
          initialValues={{
            name: userName,
            email: userEmail,
          }}
          onSubmit={() => {}}
          enableReinitialize={true}
        >
          <Form>
            {/* Name Field */}
            <div className="mb-3">
              <CustomInput
                type="text"
                name="name"
                label="Name"
                disabled
                showAstreisk={false}
                layout="stacked"
              />
            </div>

            {/* Email Field */}
            <div className="mb-3">
              <CustomInput
                type="email"
                name="email"
                label="Email"
                disabled
                showAstreisk={false}
                layout="stacked"
              />
            </div>
          </Form>
        </Formik>

        <div className="mt-4">
          <button
            type="button"
            className="btn btn-outline-primary"
            onClick={handleOpenPasswordModal}
          >
            <i className="bi bi-key me-2"></i>
            Change Password
          </button>
        </div>
      </div>

      {/* Change Password Modal */}
      {showPasswordModal && (
        <ChangePasswordModal
          showModal={showPasswordModal}
          handleClose={handleClosePasswordModal}
          handleChangePassword={handleChangePassword}
          loading={passwordLoading}
          error={passwordError}
          success={passwordSuccess}
        />
      )}
    </>
  );
};

export default SettingsForm;
